<template>
  <div class="main">
    <!-- <el-breadcrumb separator="/" class="zy-div-breadcrumb" style="z-index:10;">
      <el-breadcrumb-item> <i class="fa fa-home"></i> 首页</el-breadcrumb-item>
      <el-breadcrumb-item>日志</el-breadcrumb-item>
    </el-breadcrumb> -->
    <div class="container">
      <el-row class="queryrow">
        <el-form inline size="medium" :model="form" ref="form" :rules="rules" label-width="80px" label-position="right">
          <el-form-item label="用户名" prop="uid">
            <el-input size="small" v-model="form.uid" autocomplete="off" style="width: 140px;"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input size="small" v-model="form.password" autocomplete="off" style="width: 140px;"></el-input>
          </el-form-item>
          <el-form-item label="角色" prop="role">
            <el-select size="small" v-model="form.role" placeholder="请选择角色" style="width: 120px;">
              <el-option label="普通用户" value="user"></el-option>
              <el-option label="管理员" value="admin"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm(form)" size="small">添加</el-button>
            <el-button @click="resetForm('form')" size="small">重置</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <el-row class="utablerow">
        <el-table class="tableClass" :data="AfterChangeData" style="width: 100%" v-loading="bLoading" ref="tableData">
          <el-table-column prop="uid" label="用户名" width="180"></el-table-column>
          <el-table-column prop="role" label="角色" width="100">
            <template slot-scope="scope">
              {{ scope.row.role === 'admin' ? '管理员' : '普通用户' }}
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="电话" width="120">
            <template slot-scope="scope">
              {{ scope.row.phone === "" ? "--" : scope.row.phone }}
            </template>
          </el-table-column>
          <el-table-column prop="creator" label="创建者" width="150"></el-table-column>
          <el-table-column prop="ip" label="ip" width="180">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.ip === '' ? '--' : scope.row.ip" placement="top" effect="dark"
                popper-class="table-cell-tooltip">
                <span class="cell-text-overflow">
                  {{ scope.row.ip === "" ? "--" : scope.row.ip }}
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="mac" label="mac" width="180">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.mac === '' ? '--' : scope.row.mac" placement="top" effect="dark"
                popper-class="table-cell-tooltip">
                <span class="cell-text-overflow">
                  {{ scope.row.mac === "" ? "--" : scope.row.mac }}
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">重置密码</el-button>
              <el-button size="mini" @click="ResetGoogleSecret(scope.$index, scope.row)">重置密钥</el-button>
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize"
        layout="total,prev, pager, next" :total="tableData.length">
      </el-pagination>
      <el-dialog title="重置密码" :visible.sync="dialogEditUserFormVisible" width="30%" @close="closeDialog"
        :close-on-click-modal="false">
        <el-form size="medium" :model="editForm" ref="form" :rules="rules" label-width="20%" label-position="right">
          <el-form-item label="密码" prop="password">
            <el-input v-model="editForm.password" autocomplete="off" placeholder="请输入新密码"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogEditUserFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitEditForm(editForm)">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog title="ip地址" :visible.sync="dialogIpTableVisible" width="600px">
        <p v-for="(item, index) in row" :key="index" style="height:40px;font-size:15px">
          {{ item }}
        </p>
        <!-- <el-table :data="row">
          <el-table-column v-for="(item,index) in row" :key="index" :prop="item"></el-table-column>
        </el-table> -->
      </el-dialog>
      <el-dialog title="mac地址" :visible.sync="dialogMacTableVisible" width="600px">
        <p v-for="(item, index) in row" :key="index" style="height:40px;font-size:15px">
          {{ item }}
        </p>
        <!-- <el-table :data="row">
          <el-table-column v-for="item in row" :key="item" :prop="item"></el-table-column>
        </el-table> -->
      </el-dialog>
      <el-dialog title="密钥" :visible.sync="dialogGoogleSecretTableVisible" width="30%" top="22vh">
        <p style="height:40px;font-size:15px">{{ googleSecret }}</p>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import API from "./api.js";
import dbUserInfo from "@/proto/dbUserInfo_pb";
export default {
  name: "User",
  data() {
    return {
      dialogEditUserFormVisible: false,
      dialogIpTableVisible: false,
      dialogMacTableVisible: false,
      dialogGoogleSecretTableVisible: false,
      pageNum: 1, // 当前页
      pageSize: 15, // 每页显示条目数
      currency: "",
      exchange: "",
      startDate: "",
      endDate: "",
      googleSecret: "",
      DATA: "",
      name: "user",
      bLoading: false,
      msg: "Welcome to Userrrrrrrrrrrrrrrrrrr",
      form: {
        uid: "",
        password: "",
        role: "user"
      },
      editForm: {},
      rules: {
        uid: [{ required: true, message: "请输入用户名", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        role: [{ required: true, message: "请选择角色", trigger: "change" }]
      },
      exchangeData: [],
      options: [],
      tableData: [],
      row: []
    };
  },
  computed: {
    key() {
      return this.$route.path + new Date().getTime();
    },
    // 分页
    AfterChangeData() {
      let start = (this.pageNum - 1) * this.pageSize;
      let end = this.pageNum * this.pageSize;
      return this.tableData.slice(start, end);
    }
  },
  methods: {
    // 获取表格数据
    getTableData() {
      var data = {
        "admin-uid": localStorage.getItem("admin-uid")
      };
      API.getUserList(data)
        .then(res => {
          if (res.data.errcode === 0) {
            var buffer = res.data.buffer;
            var message = dbUserInfo.DbUserList.deserializeBinary(buffer);
            var userArray = [];
            message.getUsersList().forEach(user => {
              var ips = user.getIplistList();
              var macs = user.getMacaddrlistList();
              ips = ips.join(", ");
              macs = macs.join(", ");
              var userObj = {
                uid: user.getUid(),
                phone: user.getPhone(),
                creator: user.getCreator(),
                ip: ips,
                mac: macs,
                googleSecret: user.getGooglesecret(),
                role: user.getRole() || 'user'
              };
              userArray.push(userObj);
            });
            this.tableData = userArray;
          } else {
            this.$message.error(res.data.errcode + ":" + res.data.errmsg);
            if (res.data.errcode === 3001) {
              // 无效的登录凭证
              // this.$router.push("/adminLogin");
            }
          }
        })
        .catch(() => {
          // this.$router.push("/adminLogin");
        });
    },
    // 当前页数改变
    handleCurrentChange(val) {
      this.pageNum = val;
    },
    // 创建新用户
    submitForm(form) {
      this.$refs.form.validate(valid => {
        if (valid) {
          var data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            uid: form.uid,
            password: form.password,
            role: form.role
          };
          API.CreateUser(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.getTableData();
                this.$message({
                  message: "创建成功！",
                  type: "success"
                });
                this.resetForm();
                console.log(res.data);
                //赋值新的谷歌码
                this.googleSecret = res.data.googleSecret;
                this.dialogGoogleSecretTableVisible = true;
              } else {
                this.$message.error(res.data.errcode + "-" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "创建失败！" + error,
                type: "error"
              });
              this.resetForm();
            });
        } else {
          return false;
        }
      });
    },
    // 重置密码
    submitEditForm(editForm) {
      var Data = this.DATA;
      this.$refs.form.validate(valid => {
        if (valid) {
          var data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            uid: Data.uid,
            password: editForm.password
          };
          API.ResetPassword(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.getTableData();
                this.$message({
                  message: "重置成功！",
                  type: "success"
                });
                this.dialogEditUserFormVisible = false;
              } else {
                this.dialogEditUserFormVisible = false;
                this.$message.error(res.data.errcode + "-" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "重置失败！" + error,
                type: "error"
              });
              this.resetForm();
            });
        } else {
          return false;
        }
      });
    },
    // 清空表单数据
    resetForm() {
      if (this.$refs.form !== undefined) {
        this.$refs.form.resetFields();
      }
    },
    // 关闭弹框的事件
    closeDialog() {
      this.$refs.form.resetFields();
      this.editForm = {}; // 清空数据
    },
    // 打开重置密码弹出框
    handleEdit(index, row) {
      this.DATA = row;
      this.dialogEditUserFormVisible = true;
      // console.log(index, row)
    },
    // 重置谷歌密钥
    ResetGoogleSecret(index, row) {
      this.$confirm("确认重置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            uid: row.uid
          };
          API.ResetGoogleSecret(data)
            .then(res => {
              if (res.data.errcode === 0) {
                //重新查询
                this.getTableData();
                this.$message({
                  message: "重置成功！",
                  type: "success"
                });
                // console.log("res.data==", res.data);
                setTimeout(() => {
                  this.googleSecret = res.data.googleSecret;
                  // console.log("this.googleSecret==", this.googleSecret);
                  this.dialogGoogleSecretTableVisible = true;
                }, 300);
                // console.log('res.data.googleSecret=',res.data.googleSecret)
              } else {
                this.$message.error(res.data.errcode + "-" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "重置失败！" + error,
                type: "error"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置"
          });
        });
    },
    // 删除用户
    handleDelete(index, row) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            "admin-uid": localStorage.getItem("admin-uid"),
            uid: row.uid
          };
          API.DeleteUser(data)
            .then(res => {
              if (res.data.errcode === 0) {
                this.getTableData();
                this.$message({
                  message: "删除成功！",
                  type: "success"
                });
              } else {
                this.$message.error(res.data.errcode + "-" + res.data.errmsg);
                if (res.data.errcode === 3001) {
                  // 无效的登录凭证
                  this.$router.push("/adminLogin");
                }
              }
            })
            .catch(error => {
              this.$message({
                message: "删除失败！" + error,
                type: "error"
              });
              // console.log(error.response.data.errcode)
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  },
  created() {
    this.getTableData();
  }
};
</script>

<style scoped>
@import "../assets/css/user.scss";

/** 表格样式 */
.tableClass .cell {
  padding: 0 !important;
  height: 40px;
  line-height: 30px !important;
  text-align: center;
}
</style>

<style>
/** 表格单元格 tooltip 样式 — 必须全局样式（tooltip 被 append 到 body） */
.table-cell-tooltip {
  max-width: 400px !important;
  min-width: 80px !important;
  width: auto !important;
  padding: 8px 14px !important;
  font-size: 13px !important;
  line-height: 1.5 !important;
  word-break: break-all;
  white-space: normal !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3) !important;
}

.table-cell-tooltip.is-dark {
  background-color: #303133 !important;
  border: 1px solid #303133;
}

.table-cell-tooltip .el-tooltip__inner {
  max-width: 400px !important;
  background-color: #303133 !important;
  color: #ffffff !important;
  padding: 8px 12px !important;
  line-height: 1.5 !important;
  font-size: 13px !important;
  word-break: break-all;
  white-space: normal;
}

/** 箭头颜色调整 */
.table-cell-tooltip[x-placement^="top"] .popper__arrow {
  border-top-color: #303133 !important;
}

.table-cell-tooltip[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: #303133 !important;
}

.table-cell-tooltip[x-placement^="left"] .popper__arrow {
  border-left-color: #303133 !important;
}

.table-cell-tooltip[x-placement^="right"] .popper__arrow {
  border-right-color: #303133 !important;
}
</style>
